export const FOOTER_HEIGHT = "40px";

export const DISBURSEMENT_CATEGORY = Object.freeze({
  C: "Courier",
  CR: "Court Reporter",
  I: "Interest",
  LT: "Lawyer Travel Expenses",
  NT: "Non-Taxable",
  M: "Miscellaneous",
  O: "Other", //Keeping it here since NetSuite still has other. But should be miscellaneous
  OC: "Other Charges",
  P: "Parking",
  PMT: "Payment of Disbursements",
  PARO: "Payroll",
  PR: "Police Report",
  REV: "Reversal",
  S: "Searches",
  SER: "Service of Documents",
  SOBP: "Statement of Benefits Paid",
  TR: "Translation/Interpretation",
  TN: "Treatment Notes/Medical Report",
});

export const DISBURSEMENT_TAXABLE = Object.freeze({
  [DISBURSEMENT_CATEGORY.C.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.CR.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.I.toUpperCase()]: "No",
  [DISBURSEMENT_CATEGORY.LT.toUpperCase()]: "No",
  [DISBURSEMENT_CATEGORY.NT.toUpperCase()]: "No",
  [DISBURSEMENT_CATEGORY.M.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.O.toUpperCase()]: "Yes", //Keeping it here since NetSuite still has other. But should be miscellaneous
  [DISBURSEMENT_CATEGORY.OC.toUpperCase()]: "Other",
  [DISBURSEMENT_CATEGORY.P.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.PMT.toUpperCase()]: "Other",
  [DISBURSEMENT_CATEGORY.PARO.toUpperCase()]: "No",
  [DISBURSEMENT_CATEGORY.PR.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.REV.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.S.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.SER.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.SOBP.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.TR.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.TN.toUpperCase()]: "Yes",
});

export const EMP_DISBURSEMENT_TAXABLE = Object.freeze({
  [DISBURSEMENT_CATEGORY.C.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.CR.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.I.toUpperCase()]: "No",
  [DISBURSEMENT_CATEGORY.LT.toUpperCase()]: "No",
  [DISBURSEMENT_CATEGORY.NT.toUpperCase()]: "No",
  [DISBURSEMENT_CATEGORY.M.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.O.toUpperCase()]: "Yes", //Keeping it here since NetSuite still has other. But should be miscellaneous
  [DISBURSEMENT_CATEGORY.OC.toUpperCase()]: "Other",
  [DISBURSEMENT_CATEGORY.P.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.PMT.toUpperCase()]: "Other",
  [DISBURSEMENT_CATEGORY.PARO.toUpperCase()]: "No",
  [DISBURSEMENT_CATEGORY.PR.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.REV.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.S.toUpperCase()]: "No",
  [DISBURSEMENT_CATEGORY.SER.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.SOBP.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.TR.toUpperCase()]: "Yes",
  [DISBURSEMENT_CATEGORY.TN.toUpperCase()]: "Yes",
});
